import { Directive, ElementRef, OnInit } from '@angular/core';
import { ViewModel } from '@farris/devkit';
import { EditorComponent } from '@farris/ui-editor';

@Directive({
  selector: '[farris-editor],[farris-editor-bind]'
})
export class FarrisEditorDirective implements OnInit {
  constructor(private viewModel: ViewModel, private editor: EditorComponent) { }

  ngOnInit(): void {
    this.setComponentRef();
  }

  private setComponentRef() {
    const appContext = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.getFormAppContext();
    const frameId = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameId;
    const editor: any = this.editor;
    const elementRef: ElementRef = editor && editor.injector && editor.injector.get(ElementRef, null);
    const id = elementRef && elementRef.nativeElement && elementRef.nativeElement.id || null;
    // å¦æframeIdä¸å­å¨ætreetableæ²¡æidå±æ§ï¼è¯´æä¸ç¬¦åä½¿ç¨åºæ¯
    if (!frameId || !id) {
      return;
    }
    const map = appContext && appContext.componentRefs && appContext.componentRefs.get(frameId) || new Map<string, any>();
    appContext && appContext.componentRefs && appContext.componentRefs.set(frameId, map.set(id, this.editor));
  }
}